import {Articles} from "@/pages/common/Home/Dissection/Articles";
import {Intro} from "@/pages/common/Home/Dissection/Intro";

import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const Dissection = () => {
  const {t} = useTranslation();

  return (
    <>
      <Helmet title={t("head_title.analytics")} />

      <div className={"container-big"}>
        <div className={styles.dissection}>
          <Intro />

          <Articles />
        </div>
      </div>
    </>
  );
};
